import { FieldType, Model, Schema } from "@core/index";
import { IContactAddress } from "./ContactAddress";
import { IContactEmail } from "./ContactEmail";
import { IContactNumber } from "./ContactNumber";
import { ICountry } from "./Country";
import { PassengerType } from "./PaxFare";
import { IPerson } from "./Person";
import { ITicket } from "./Ticket";
import { ITravelDoc } from "./TravelDoc";

export interface ITraveler extends IPerson {
    paxNo?: number;
    refNumber?: string;
    paxType?: PassengerType;
    tickets?: ITicket[];
    shareUrl?: string;
    travelWith?: string;
    verifiedMemberId?: boolean;
}

export class Traveler extends Model implements ITraveler {
    public static schema: Schema = new Schema("Traveler");
    public gender?: string;
    public prefix?: string;
    public firstName?: string;
    public lastName?: string;
    public localFirstName?: string;
    public localLastName?: string;
    public memberId?: string;
    public birthDate?: number;
    public nationality?: ICountry;
    public travelDocs?: ITravelDoc[] = [];
    public telephone?: IContactNumber = {};
    public mobile?: IContactNumber = {};
    public email?: IContactEmail = {};
    public address?: IContactAddress = {};
    public paxNo?: number;
    public refNumber?: string;
    public paxType?: PassengerType;
    public tickets?: ITicket[];

    constructor(values: ITraveler) {
        super(Traveler.schema);
        this.setValues(values);
    }
}

Traveler.schema.addField("gender").type(FieldType.String).required();
Traveler.schema.addField("prefix").type(FieldType.String).required();
Traveler.schema.addField("firstName").type(FieldType.String).required().pattern(/^[a-zA-Z ]*$/);
Traveler.schema.addField("lastName").type(FieldType.String).required().pattern(/^[a-zA-Z ]*$/);
Traveler.schema.addField("localFirstName").type(FieldType.String).pattern( /^[\u0600-\u06FF\s]+$/);
Traveler.schema.addField("localLastName").type(FieldType.String).pattern( /^[\u0600-\u06FF\s]+$/);
Traveler.schema.addField("memberId").type(FieldType.Number).required().pattern(/^[0-9]{9}$/);
Traveler.schema.addField("birthDate").type(FieldType.Timestamp).required();
Traveler.schema.addField("nationality").type(FieldType.Object).required();
Traveler.schema.addField("travelDocs").type(FieldType.List);
Traveler.schema.addField("mobile").type(FieldType.Object);
Traveler.schema.addField("email").type(FieldType.Object);
Traveler.schema.addField("address").type(FieldType.Object);
Traveler.schema.addField("paxNo").type(FieldType.Number).required();
Traveler.schema.addField("refNumber").type(FieldType.String).required();
Traveler.schema.addField("paxType").type(FieldType.Enum)
    .enum(PassengerType.ADT, PassengerType.CHD, PassengerType.INF).default(PassengerType.ADT);
Traveler.schema.addField("tickets").type(FieldType.List);
Traveler.schema.freeze();

export function mapPersonToTraveler(traveler: ITraveler, person: IPerson) {
    traveler.address = person.address;
    traveler.birthDate = person.birthDate;
    traveler.email = person.email;
    traveler.firstName = person.firstName;
    traveler.gender = person.gender;
    traveler.guid = person.guid;
    traveler.lastName = person.lastName;
    traveler.localFirstName = person.localFirstName;
    traveler.localLastName = person.localLastName;
    traveler.memberId = person.memberId;
    traveler.mobile = person.mobile;
    traveler.nationality = person.nationality;
    traveler.prefix = person.prefix;
    traveler.telephone = person.telephone;
    traveler.travelDocs = person.travelDocs;
    traveler.preferredLangauge = person.preferredLangauge;
    return traveler;
}